export default [
    {
        path:'/dashboard',
        name:'dashboard',
        component: () => import('../../views/Dashboard/Dashboard.vue'),
        meta: {title: 'Inicio - DOrrico',  requireAuth: true, layout: 'admin'},
    }
]